export const LANGUAGE_STORAGE_KEY = 'tr-language'
export const DEFAULT_LANGUAGE = 'en'

// Keep this list as the single source of truth for language support.
// To add a future language, uncomment/add it here and set `available: true`.
// Codes must match Google Translate's combo option values (and the googtrans
// cookie): Simplified Chinese is `zh-CN` (Traditional would be `zh-TW`),
// Brazilian Portuguese is `pt`, Spanish `es`, Russian `ru`, Japanese `ja`.
// English stays first as the source/default and the way back from a translation.
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸', available: true },
  { code: 'zh-CN', name: 'Simplified Chinese (简体中文)', flag: '🇨🇳', available: true },
  { code: 'ru', name: 'Russian (Русский)', flag: '🇷🇺', available: true },
  { code: 'pt', name: 'Brazilian Portuguese (Português)', flag: '🇧🇷', available: true },
  { code: 'es', name: 'Spanish (Español)', flag: '🇪🇸', available: true },
  { code: 'ja', name: 'Japanese (日本語)', flag: '🇯🇵', available: true },
  { code: 'de', name: 'German (Deutsch)', flag: '🇩🇪', available: true }

  // { code: 'fr', name: 'French (Français)', flag: '🇫🇷', available: false },
  // { code: 'ar', name: 'Arabic (العربية)', flag: '🇸🇦', available: false },
  // { code: 'tr', name: 'Turkish (Türkçe)', flag: '🇹🇷', available: false }
]

export const getAvailableLanguages = () =>
  SUPPORTED_LANGUAGES.filter(language => language.available)

export const isSupportedLanguage = code =>
  getAvailableLanguages().some(language => language.code === code)
